<template>
    <div v-if="widthMin" class="pull-right mx-2">
        <div @click="updateSize" >
            <i class="fas fa-expand-arrows-alt text-warning"></i>
        </div>
    </div>
</template>

<script>
// import { useStore } from 'vuex';
import axios from '@/axios'
import { useStore } from 'vuex';

export default {
    name:"sizeWidget",
    props: ["id"],
    setup(props){
        const store = useStore()
        const sendNewSize = () => {
            const axiosHeaders = {
                headers: {
                    token : store.state.auth.token
                }
            }
            data = {
                id : store.state.selectedDevice.template.templateid ,
                size : "col-md-6 col-sm-12"
            }
            axios.put("/api/update-widget-size", data, axiosHeaders).then((res) => res.json)
            .then((json) => {
                console.log("testing new size widget")
            }).catch((err)=>{
                console.log(err)
            })
        }

        const updateSize = () =>{
            try {
            const element = document.getElementById(props.id)
       
            if ( element.className.includes("col-12") ){
                element.className = "col-md-8 col-sm-12"
            } else if (element.className.includes("col-md-8") ){
                element.className = "col-md-6 col-sm-12"
            }
            else if (element.className.includes("col-md-6") ){
                element.className = "col-md-4 col-sm-12"
            } else if (element.className.includes("col-md-4") ) {
                element.className = "col-md-3 col-sm-12"
            } else if (element.className.includes("col-md-3") ) {
                element.className = "col-12"
            }
        } catch (err){
            console.log("")
        }
        }
        const widthMin = window.innerWidth > 990 ? true : false

        return {
            updateSize,
            widthMin
        }
    }

}

</script>